module.exports = "/static/media/password_lock.0628993f.jpg";